import { useEffect } from 'react'

export const ChatwootWidget = () => {
    useEffect(() => {
        const APP_MODE = import.meta.env.MODE
        const BASE_URL = import.meta.env.VITE_CHATWOOT_PATH

        const websiteToken = APP_MODE == 'production'
            ? import.meta.env.VITE_CHATWOOT_PROD_TOKEN
            : import.meta.env.VITE_CHATWOOT_DEV_TOKEN

        if (window.chatwootSDK) return

        window.chatwootSettings = {
            hideMessageBubble: false,
            position: "right",
            locale: "en",
            type: "standard",
            darkMode: "auto",
        }

        const script = document.createElement("script")
        script.src = `${BASE_URL}/packs/js/sdk.js`
        script.async = true
        script.onload = () => {
            window?.chatwootSDK?.run({
                websiteToken,
                baseUrl: BASE_URL,
            })
        }

        document.body.appendChild(script)
    }, [])

    return null
}
